import React from 'react';
import { RegisterItemList } from './RegisterItemList';

export const RemediationList: React.FC = () => {
  return (
    <RegisterItemList
      title="Remediations"
      iconClass="ri-tools-line"
      listPath="/remediations"
      detailPathPrefix="/remediations"
      configPath="/remediation-config"
      registersPath="/remediation-registers"
      idField="remediationId"
      titleField="remediation_title"
      priorityField="remediation_priority"
      statusField="remediation_status"
      registerQueryParam="registerId"
    />
  );
};
